type MakeCatalogConfig = () => {
  values: {
    authToken: string;
    operationId: string;
    locale: string;
  };
  catalogConfig: {
    getAuthToken: jest.Mock<string>;
    getOperationId: jest.Mock<string>;
    getLocale: jest.Mock<string>;
  };
};

export const makeCatalogConfig: MakeCatalogConfig = () => {
  const authToken = "AUTH_TOKEN";
  const operationId = "OPERATION_ID";
  const locale = "LOCALE";
  const getAuthToken = jest.fn(() => authToken);
  const getOperationId = jest.fn(() => operationId);
  const getLocale = jest.fn(() => locale);
  return {
    values: {
      authToken,
      operationId,
      locale,
    },
    catalogConfig: {
      getAuthToken,
      getOperationId,
      getLocale,
    },
  };
};
